import SingleSelectedProperty from "../../../../common/state/modules/singleSelectedProperty";
import Dashboard from "~/models/dashboards/dashboard";
import DashboardElement from "~/models/dashboards/dashboardElement";
import GloballySelected from "~/state/modules/globallySelected";

export default class Selected extends GloballySelected {
  static element = new SingleSelectedProperty('dashboardElement', () => DashboardElement);
  static dashboard = new SingleSelectedProperty('dashboard', () => Dashboard)
}